import React from 'react';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card';

const AnonymousReportCard: React.FC<{ className?: string }> = ({
  className,
}) => (
  <Card className={className}>
    <CardHeader>
      <CardTitle>Fazer denúncia</CardTitle>
      <CardDescription></CardDescription>
    </CardHeader>
    <CardContent className="flex flex-col items-center justify-center gap-4">
      <Button className="gap-2">Denúncia Anônima</Button>
    </CardContent>
  </Card>
);

export default AnonymousReportCard;
